import * as React from 'react';
import './HelpLink.css';
import ButtonLabel from '../../Buttons/ButtonLabel/ButtonLabel';
import Icon from '../../Icons/Icon/Icon';
import { ReactComponent as ExternalLink } from '../../../icons/ExternalLink/ExternalLink.svg';
export default function (_ref) {
  var label = _ref.label,
    to = _ref.to;
  return /*#__PURE__*/React.createElement("a", {
    href: to,
    target: "_blank",
    rel: "noopener noreferrer",
    className: "_dm-button _dm-button--icon _dm-button--help auto-help-link"
  }, label && /*#__PURE__*/React.createElement(ButtonLabel, {
    i18n: label,
    hideLabel: true
  }), /*#__PURE__*/React.createElement(Icon, {
    icon: ExternalLink,
    className: '_dm-icon--help-link',
    height: "1rem"
  }));
}